var Plugin = require("common/Plugin");
var AppsController = require("apps/AppsController");
var AppRenderer = require("apps/AppRenderer");
var WebForwardLauncher = require("web_forwards/WebForwardLauncher");

function AppsPlugin() {
    var self = this;

    this.start = function() {
        var appsController = new AppsController();
        var renderer = new AppRenderer();

        appsController.addResourceType("web_forward", new WebForwardLauncher(), renderer);

        // Register view with app controller
        self.registerController(appsController);
    };
}

AppsPlugin.prototype = Plugin;

module.exports = AppsPlugin;